import { type MetaFunction } from 'react-router';
import { type OrganizationLoaderData } from './loader';

export const meta: MetaFunction = ({ data }) => {
  const loaderData = data as OrganizationLoaderData;
  if (!loaderData) {
    return [];
  }
  return [
    { title: loaderData.organization.name },
    {
      name: 'description',
      content: loaderData.organization.description,
    },
  ];
};
